<div class="flex-direction-column height-100 page">
  <div class="flex-direction-row justify-between align-center">
  </div>
  <div class="flex-direction-column container-perfil gap-15 justify-between">
    @if (usuarioLogado) {
      <div class="flex-direction-column gap-15">
        @if (!usuarioLogado.extensaoImg) {
          <div class="width-100 flex justify-center margin-top-15 margin-bottom-25">
            <app-balao-sugestao (envioImg)="receberImgUsuario($event)"></app-balao-sugestao>
          </div>
        }
        <div class="margin-top-15">
          <app-info-usuario [usuario]="usuarioLogado" [imgUsuario]="imgUsuario" (envioImagem)="receberImgUsuario($event)"></app-info-usuario>
        </div>
        @if (usuarioLogado.canais && usuarioLogado.canais.length > 0) {
          <div>
            <app-canais-usuarios [canais]="usuarioLogado.canais!">
            </app-canais-usuarios>
          </div>
        }
        <div class="card-separacao flex align-center">
          <span class="font-10 weight-600">Troca de Senha</span>
        </div>
        @if (!usuarioLogado.ldapHabilitado) {
          <div class="flex-direction-column gap-10" style="padding-left: 10px;">
            <app-form-field
              label="Senha Atual"
              [value]="senhasObj.senhaAtual"
              heightFormField="30px"
              [widthFormField]="'324px'"
              (changeValue)="senhasObj.senhaAtual = $event"
              [isSenha]="true"
            >
            </app-form-field>
            <app-form-field
              label="Nova Senha"
              [value]="senhasObj.novaSenha"
              heightFormField="30px"
              [widthFormField]="'324px'"
              (changeValue)="senhasObj.novaSenha = $event"
              [isSenha]="true"
            >
            </app-form-field>
            <app-form-field
              label="Repetir Nova Senha"
              [value]="senhasObj.confirmacaoNovaSenha"
              heightFormField="30px"
              [widthFormField]="'324px'"
              (changeValue)="verificarConfirmacaoSenha($event)"
              [isSenha]="true"
            >
            </app-form-field>
            <app-button-padrao
              [width]="'325px'"
              [borderRadius]="'7px'"
              [label]="'Salvar'"
              [fontSize]="'14px'"
              [backgroundColor]="'#61B460'"
              (buttonClick)="trocarSenhaUsuario()"
            >
            </app-button-padrao>
          </div>
        }
        @else {
          <div class="width-100 flex justify-center">
            <app-balao-usuario-ad></app-balao-usuario-ad>
          </div>
        }
      </div>
    }

    <div class="width-100 flex justify-center margin-bottom-15">
      <app-button-padrao
        [width]="'323px'"
        [borderRadius]="'7px'"
        [label]="'Sair do sistema'"
        [fontSize]="'14px'"
        [backgroundColor]="'#fff'"
        [color]="'#C60000'"
        [borderColor]="'#C60000'"
        [borderStyle]="'solid'"
        [borderWidth]="'1px'"
        (buttonClick)="logout()"
      >
      </app-button-padrao>
    </div>
  </div>
</div>
